import { ConsignmentQuestion } from 'types';

export function consignmentQuestionFactory(
  params: any = []
): ConsignmentQuestion[] {
  return params.map((param: any) => {
    const { consignmentCode, customerName, deliveryMode, questionDate } =
      param || {};

    return {
      consignmentCode: consignmentCode ?? '',
      customerName: customerName ?? '',
      deliveryMode: deliveryMode ?? '',
      questionDate: questionDate ?? 0,
    };
  });
}
